export const cacheKeys = {
  getRefillRequestMessages: (params) =>
    params
      ? ['getRefillRequestMessages', params]
      : ['getRefillRequestMessages'],
};
